import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import "./BankDetails.css";
import { BACKEND_URL } from "../../../config";

function BankDetails() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [cartItems, setCartItems] = useState(
    JSON.parse(localStorage.getItem("cart")) || []
  );

  const shippingData = JSON.parse(localStorage.getItem("shippingData")) || {};
  const medicalData = JSON.parse(localStorage.getItem("medicalData")) || {};

  const pendingOrder = JSON.parse(localStorage.getItem("pendingOrder")) || {};

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (cartItems.length === 0) {
      navigate("/checkout");
    }
  }, [cartItems, navigate]);

  // Safety net: if there's no valid Bank Transfer pendingOrder (e.g. it
  // belongs to a different payment method, or was already cleared after
  // a successful payment), send the user back to choose a payment method
  // again instead of showing a stale or missing reference.
  useEffect(() => {
    if (!pendingOrder.orderId || pendingOrder.paymentMethod !== "Bank Transfer") {
      navigate("/checkout/payment");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.qty, 0);
  const shipping = cartItems.length > 0 ? 25 : 0;
  const discount = 0;
  const total = subtotal + shipping - discount;

  const orderReference = pendingOrder.reference || "N/A";

  const confirmPayment = async () => {
    if (!pendingOrder.orderId) {
      alert("Order not found");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${BACKEND_URL}/api.php?module=orders&action=updateStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: pendingOrder.orderId,
            status: "Payment Submitted"
          })
        }
      );

      const data = await response.json();

      if (data.success) {
        const orderSnapshot = {
          cart: cartItems,
          shippingData,
          medicalData,
          paymentMethod: "Bank Transfer",
          subtotal,
          shipping,
          discount,
          total,
          invoiceNumber: pendingOrder.reference,
          orderId: pendingOrder.orderId,
          orderDate: new Date().toISOString()
        };

        localStorage.setItem("lastOrder", JSON.stringify(orderSnapshot));

        localStorage.removeItem("cart");
        localStorage.removeItem("shippingData");
        localStorage.removeItem("medicalData");
        localStorage.removeItem("pendingOrder");

        window.dispatchEvent(new Event("cartUpdated"));

        navigate("/success");
      } else {
        alert("Update failed");
      }
    } catch (err) {
      alert("Server error");
    } finally {
      setLoading(false);
    }
  };

  if (cartItems.length === 0) {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>Bank Transfer Payment</title>
        <link rel="canonical" href="https://realgenericshop.com/bank-details" />
      </Helmet>

      <div className="bank-page">

        <div className="bank-container">

          <div className="bank-header">
            <h1>Bank Transfer Payment</h1>
            <p>
              Please transfer the exact amount using the
              bank details below.
            </p>
          </div>

          <div className="bank-card">

            <div className="bank-row">
              <span>Account Holder Name</span>
              <strong>Juli Yogeshbhai Gangani</strong>
            </div>
            <p className="bank-warning">
              Do not add anything else to account name, no website, no products.
            </p>

             <div className="bank-row">
              <span>Account Type</span>
              <strong>Deposit</strong>
            </div>

            <div className="bank-row">
              <span>Routing Number(for Wire and ACH)</span>
              <strong>084009519</strong>
            </div>


            <div className="bank-row">
              <span>Account Number</span>
              <strong>386410499328229</strong>
            </div>

           
            <div className="bank-row">
              <span>SWIFT / BIC</span>
              <strong>TRWIUS35XXX</strong>
            </div>

            <div className="bank-row">
                <span>Bank Address</span>
                <strong>
                Wise US Inc,<br />
                108 W 13th St,<br />
                Wilmington, DE 19801,<br />
                United States
                </strong>
            </div>

            <div className="bank-row">
              <span>Reference</span>
              <strong>{orderReference}</strong>
            </div>
            <p className="bank-warning">
              Do not add anything else to the Reference column, otherwise the
              payment will not be identified. Only the reference number above
              will be accepted!!!
            </p>

            <p className="bank-note">
              Please use this reference exactly as shown while making the bank transfer.
            </p>

          </div>

          <div className="bank-total-card">

            <h3>Order Summary</h3>

            {cartItems.map((item, index) => (
              <div className="bank-summary-item" key={index}>
                <span>
                  {item.productName} ({item.qty} × {item.packSize})
                </span>
                <span>
                  €{(item.price * item.qty).toFixed(2)}
                </span>
              </div>
            ))}

            <div className="total-row">
              <span>Subtotal</span>
              <span>€{subtotal.toFixed(2)}</span>
            </div>

            <div className="total-row">
              <span>Shipping</span>
              <span>€{shipping.toFixed(2)}</span>
            </div>

            <div className="total-row grand">
              <span>Total</span>
              <span>€{total.toFixed(2)}</span>
            </div>

          </div>

          <div className="shipping-card">

            <h3>Shipping Address</h3>

            <p>
              {shippingData.firstName}{" "}
              {shippingData.lastName}
            </p>

            <p>{shippingData.address}</p>

            <p>
              {shippingData.city},{" "}
              {shippingData.country}
            </p>

            <p>{shippingData.phone}</p>

          </div>

          <div className="bank-buttons">

            <button
              className="paid-btn"
              onClick={confirmPayment}
              disabled={loading || !pendingOrder.orderId}
            >
              {loading ? "Processing..." : "I Have Made Payment"}
            </button>

          </div>

        </div>

      </div>
    </>
  );
}

export default BankDetails;
